module.exports = __webpack_public_path__ + "assets/img/141.f04cdfae.png";